import React from "react";
import { createRoot } from "react-dom/client";

import MuxPlayerWrapper from "@components/mux-player-wrapper";

const videos = document.querySelectorAll("[data-behavior~=mux-player]");

if (videos.length > 0) {
  videos.forEach((video) => {
    const slug = video.dataset.slug;
    const { env } = window;
    const params = env[slug];

    const root = createRoot(video);
    root.render(<MuxPlayerWrapper params={params} />);
  });
}
